const appKey = "booom2022horror"
const cdnUrl = "https://site.gcores.com"

const title = "BOOOM游戏创作中元节特别活动，启动！"
const desc = "本次以恐怖游戏开发为主题材，来一起玩玩吧～"

const config = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  links: {
    xhs: "https://www.xiaohongshu.com/apps/vincent/ditto?id=112233&naviHidden=yes&utm_source=social&useNativeChannel=yes&fullscreen=true",

    // horror
    gixos: "https://site.gcores.com/gix-os/",
    enroll: "https://shimo.im/forms/XKq4MMX8wZTpxlkN/fill",
    team: "https://www.gcores.com/topics/192",
    wechat: "https://kaihei.co/4iLhB3",
    review:
      "https://www.taptap.com/video/1952058/embed?thumb=https%3A%2F%2Fimg2.tapimg.com%2Fbbcode%2Fimages%2F016cab6cae67c0c4e6da36028db3cced.png",
    upload: "https://www.gcores.com/games/form",
    event2022: "https://site.gcores.com/booom2022",
    event2022Games: "https://site.gcores.com/booom2022/games/",
    guide:
      "https://friendly-dime-41c.notion.site/4821fe6f9b174d82a54d2ee462f2a8f7",
  },
}
module.exports = config
